import { keyframes } from '@mui/system';

// The spinner only shows when the wait lasts: a preloaded video starts before it appears.
const appear = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const video = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  pointerEvents: 'none',
};

const styles = {
  video,
  videoLandscape: {
    ...video,
    objectFit: 'contain',
  },
  buffering: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    mt: '-17px',
    ml: '-17px',
    color: 'rgba(255, 255, 255, 0.8)',
    pointerEvents: 'none',
    animation: `${appear} 200ms ease-out 400ms both`,
  },
};

export default styles;
